export const USER_KEY = 'user';

export const VEHICLE_GOV_NUMBERS_KEY = 'vehicle_gov_number';

export const VERHICLE_MODULES_KEY = 'vehicle_model';
